import { StockReconciliationUploadRow } from '@/types';
import { normalizeStockHeader } from './customerStockFields';
import { normalizeVin } from './detectVinColumn';

export type StockUploadColumns = {
  vin: string;
  location?: string;
  model?: string;
};

const columnValue = (row: Record<string, string>, column?: string) => {
  if (!column) return '';
  const key = Object.keys(row).find(
    (name) => normalizeStockHeader(name) === normalizeStockHeader(column),
  );
  return key ? (row[key] ?? '').trim() : '';
};

export const prepareStockUploadRows = (
  rows: Record<string, string>[],
  columns: StockUploadColumns,
): StockReconciliationUploadRow[] => {
  const counts = new Map<string, number>();
  const first = new Map<string, StockReconciliationUploadRow>();
  rows.forEach((row) => {
    const vin = normalizeVin(columnValue(row, columns.vin));
    if (!vin) return;
    counts.set(vin, (counts.get(vin) ?? 0) + 1);
    if (first.has(vin)) return;
    first.set(vin, {
      vin,
      locnDescr: columnValue(row, columns.location),
      modelDescr: columnValue(row, columns.model),
      dupedInSource: false,
    });
  });
  return [...first.values()].map((row) => ({
    ...row,
    dupedInSource: (counts.get(row.vin) ?? 0) > 1,
  }));
};

export const STOCK_UPLOAD_PAGE_SIZE = 500;
